import {combineReducers} from 'redux';
import landingbuilderReducer from "./landingbuilderReducer";
import componentsReducer from "./componentsReducer";

export default combineReducers({
    values: landingbuilderReducer,
    components: componentsReducer,
});
